import * as React from 'react'
import { SVGProps } from 'react'

const SvgZoomIn = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 512" {...props}>
    <path d="M386.348 336.165c23.574-34.148 37.408-75.546 37.408-120.19 0-117.015-94.843-211.878-211.878-211.878S0 98.959 0 215.974s94.843 211.878 211.878 211.878c48.849 0 93.8-16.572 129.637-44.338l124.388 124.388L512 461.812zm-174.47 46.052c-91.667 0-166.243-74.574-166.243-166.243 0-91.667 74.574-166.243 166.243-166.243s166.243 74.574 166.243 166.243-74.576 166.243-166.243 166.243z" />
    <path d="M234.695 196.417v-81.493H189.06v81.493h-81.491v45.635h81.491v81.491h45.635v-81.491h81.492v-45.635z" />
  </svg>
)

export default SvgZoomIn
